import { FC } from "react";
import { useTranslation } from "react-i18next";

import { TableDataCell } from "@digital-services/ui";
import { CopyToClipboard, TableDataCellTruncated } from "@ds-cps/ui";

import { AuditLogModel } from "@audit-log/models";

import { formatterShort } from "@utils/time-utils";

const truncateUUID = (str: string) => str.slice(0, 6) + " ...";

interface Props {
  data: AuditLogModel;
  onRowClick: () => void;
}

export const AuditLogRow: FC<Props> = props => {
  const { data, onRowClick } = props;

  const { t: tCommon } = useTranslation(undefined, {
    keyPrefix: "common"
  });

  const { t: tAuditLog } = useTranslation(undefined, {
    keyPrefix: "audit-log"
  });

  return (
    <tr
      key={`table-row-${data.id}`}
      className="cursor-pointer [&:hover_td:first-child_div]:block"
      data-testid={`table-row-${data.id}`}
      onClick={onRowClick}
    >
      <TableDataCell title={data.timestamp}>
        {data.timestamp ? formatterShort(data.timestamp) : "-"}
      </TableDataCell>

      <TableDataCell className="group min-w-[150px]">
        <span>{truncateUUID(data.id)}</span>
        <span className="invisible ml-1 group-hover:visible">
          {data.id ? (
            <CopyToClipboard
              value={data.id}
              message={tCommon("copied-to-clipboard", {
                entityName: tAuditLog("table.headers.id")
              })}
            />
          ) : null}
        </span>
      </TableDataCell>

      <TableDataCell>{data.userEmail || "-"}</TableDataCell>

      <TableDataCellTruncated value={data.organization} />

      <TableDataCell className="group max-w-[100px]">
        <span>{data.resource || "-"}</span>
        {data.resource ? (
          <span className="invisible ml-1 group-hover:visible">
            <CopyToClipboard
              value={data.resource}
              message={tCommon("copied-to-clipboard", {
                entityName: tAuditLog("table.headers.resource")
              })}
            />
          </span>
        ) : null}
      </TableDataCell>

      <TableDataCell>{data.application || "-"}</TableDataCell>
      <TableDataCell>{data.userContextEmail || "-"}</TableDataCell>
      <TableDataCell>{data.sourceApplicationName || "-"}</TableDataCell>

      <TableDataCell className="group">
        <span>{data.action || "-"}</span>
        <span className="invisible ml-1 group-hover:visible">
          {data.action ? (
            <CopyToClipboard
              value={data.action}
              message={tCommon("copied-to-clipboard", {
                entityName: tAuditLog("table.headers.action")
              })}
            />
          ) : null}
        </span>
      </TableDataCell>
    </tr>
  );
};
